export default class Status {

    id: number;
    desc: string;
    // bootstrap vue only sees value and text in their selectors
    value: number;
    text: string;

    constructor(){
        this.id = 0;
        this.desc = "";
        this.value = 0;
        this.text = "";
    }
}